<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Pos</th>
          <th v-for="c in cols.filter(c => cols.indexOf(c) > -1)" v-bind:key="c">{{ c }}</th>
        </tr>
      </thead>
      <tr v-for="player in data" v-bind:key="player.name">
        <td>{{ player.Name }}</td>
        <td>{{ player.Pos }}</td>
        <td v-for="c in cols.filter(c => cols.indexOf(c) > -1)" v-bind:key="c">{{ player[c] }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
// import PostHeader from '../../post-sections/post-header.vue';

// import bindLoadData from './app/loadData.js';
// import bindParams from './app/params.js';
// import bindSlides from './app/slides.js';
// import bindHelpers from './app/helpers.js';
// import bindBuildMap from './app/buildMap.js';
// import bindBuildGraphs from './app/buildGraphs.js';
// import bindActions from './app/actions.js';

export default {
    name: 'compare-table',
    props: ['data', 'cols'],
    mounted() {
        // const mainApp = {};
        // bindLoadData(mainApp);
        // bindParams(mainApp);
        // bindSlides(mainApp);
        // bindHelpers(mainApp);
        // bindBuildMap(mainApp);
        // bindBuildGraphs(mainApp);
        // bindActions(mainApp);
        // mainApp.curSlide = 0;
        // mainApp.loadData(() => {
        //     mainApp.setParams();
        //     mainApp.setSlideParams();
        //     mainApp.buildMap();
        //     mainApp.year(1950);
        //     mainApp.showSlide(mainApp.curSlide);
        // });
    }
};
</script>

<style scoped>
table {
    width: 100%;
}
</style>
